import React from "react";

const STAR_COUNT = 60;

function getRandomStyle() {
  const top = Math.random() * 100;
  const left = Math.random() * 100;
  const size = 1 + Math.random() * 2.5;
  const delay = Math.random() * 2;
  const moveDuration = 2 + Math.random() * 2;
  return {
    position: "absolute",
    top: `${top}%`,
    left: `${left}%`,
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: "50%",
    background: "white",
    opacity: 0.8,
    animation: `starBlink 1.5s infinite alternate, starMove ${moveDuration}s ease-in-out infinite alternate`,
    animationDelay: `${delay}s, ${delay}s`,
    pointerEvents: "none",
  };
}

function StarParticles() {
  return (
    <div
      className="star-particles"
      style={{ position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none" }}
    >
      {/* Tiny moving stars */}
      {Array.from({ length: STAR_COUNT }).map((_, i) => (
        <div key={i} style={getRandomStyle()} />
      ))}
    </div>
  );
}

export default StarParticles;